import { ChangeDetectorRef, Directive, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { KendoGridSort } from '../../../lib/models/dto/case-search/kendo-grid-sort.model';
import { EntityResponseDto } from '../../../lib/models/dto/entity-response-dto.model';
import { ReferenceData } from '../../../lib/models/reference-data.model';
import { ReferenceDataService } from '../../../lib/services/reference-data.service';
import { ProductDto } from '../../models/product-dto.model';

@Directive()
export class BaseProductPickerListViewComponent implements OnChanges {
  @Input() public products: Array<EntityResponseDto<ProductDto>>;
  @Input() public isCriteriaSearch: boolean;
  @Input() public isSelectionDisabled: boolean;
  @Output() public readonly selectProduct = new EventEmitter<ProductDto>();
  @Output() public readonly sortOptionChange = new EventEmitter<KendoGridSort>();
  @Input() public set useInitialSortOption(value: boolean) {
    if (value) {
      this.selectedSortOption = this.sortOptions[0];
      this.updateSelectedSortOption();
      this.ref.detectChanges();
    }
  }

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public selectedProduct: ProductDto;
  public sortOptions: Array<ReferenceData>;
  public selectedSortOption: ReferenceData;
  public numberOfAvailableProducts: number;
  public isProductSpecialFeatureDialogOpen: boolean;

  constructor(protected ref: ChangeDetectorRef, protected referenceDataService: ReferenceDataService) {
    this.sortOptions = this.referenceDataService.getOptionListConfigItems(this.getSortOptionKey());
    this.selectedSortOption = this.sortOptions[0];
  }

  public trackByProductId(index, item): void {
    return item.Entity.ProductID;
  }

  public updateSelectedSortOption(): void {
    this.sortOptionChange.emit(new KendoGridSort().initFromRefDataSort(this.selectedSortOption));
  }

  public chooseProduct(product: ProductDto): void {
    if (product.ProductSpecialFeatures.length > 0) {
      this.isProductSpecialFeatureDialogOpen = true;
      this.selectedProduct = product;
      this.ref.detectChanges();
    } else {
      this.selectProduct.emit(product);
    }
  }

  public confirmProduct(): void {
    this.isProductSpecialFeatureDialogOpen = false;
    this.ref.detectChanges();
    this.selectProduct.emit(this.selectedProduct);
  }

  public cancelProductSpecialFeatures(): void {
    this.isProductSpecialFeatureDialogOpen = false;
    this.ref.detectChanges();
  }

  protected getSortOptionKey(): string {
    return;
  }

  private getNumberOfAvailableProducts(products: Array<EntityResponseDto<ProductDto>>): number {
    const availableProducts = products
      ? products.filter(
          (p) => p.ValidationErrors.FullValidationErrors && p.ValidationErrors.FullValidationErrors.length === 1
        )
      : [];

    return availableProducts.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isSelectionDisabled && changes.isSelectionDisabled.currentValue) {
      this.ref.detectChanges();
    }
    if (changes.products && changes.products.currentValue !== changes.products.previousValue) {
      this.numberOfAvailableProducts = this.getNumberOfAvailableProducts(changes.products.currentValue);
      this.ref.detectChanges();
    }
  }
}
